module.exports = __webpack_public_path__ + "img/700_Websites-and-links.7bfd88d8.png";